import type { IconSvgObject } from './types';

const KeyframeAlignHorizontalIcon: IconSvgObject = [
  ["path", { d: "M15.2586 11.3348L12.7143 8.33607C12.3341 7.88798 11.6659 7.88798 11.2857 8.33607L8.74141 11.3348C8.41953 11.7142 8.41953 12.2858 8.74141 12.6652L11.2857 15.6639C11.6659 16.112 12.3341 16.112 12.7143 15.6639L15.2586 12.6652C15.5805 12.2858 15.5805 11.7142 15.2586 11.3348Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 12L2 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 12L19 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default KeyframeAlignHorizontalIcon;
